/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * slider-fade-normail.js
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * Imprt swiper.
 */
import Swiper from "swiper/bundle";

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * Setting - Fade Slider - デフォルト
 */
const option = {
	loop: true,
	slidesPerView: "auto",
	effect: "fade",
	noSwiping: "true",
	noSwipingClass: "no-swipe",
	preventClicks: true,
	autoplay: {
		delay: 4000,
		disableOnInteraction: false,
	},
	speed: 3000,
};

const option_slide = {
	loop: true,
	autoplay: {
		delay: 3000,
		disableOnInteraction: false,
	},
	pagination: {
		el: ".swiper-pagination",
		clickable: true,
	},
	speed: 1000,
};

/**
 * Action - Fade Slider - デフォルト
 */
const sliderFadeNormal = new Swiper(".slider-fade", option_slide);